import { post } from '@/utils/request'

//获取列表
export function getList(data) {
    return post('psi/log/listLog', data)
}

